module.exports = __webpack_public_path__ + "static/media/Iconly-Bold-Paper-Blue.a4fc18e1.svg";